<template lang="">
    <div>
        <swiper :options="swiperOption" ref="mySwiper" class="swiper">
            <swiper-slide class="swiper-slide swiper-container-3d swiper-list" :style="apptype=='Roewe'?'width:2.01rem;height:3.78rem;':'width: 2.46rem;height: 4.1rem;'" v-for="(banner,index) in commodityList" :key="index">
                <img :style="apptype=='Roewe'?'width:2.01rem;height:3.78rem;':'width: 2.46rem;height: 4.1rem;'" @click="skipLink(banner)" :src="banner.img" />
            </swiper-slide>
            <!-- 分页器 -->
            <!-- <div class="swiper-pagination" slot="pagination"></div> -->
            <!-- 左右箭头 -->
            <!-- @click="prev" -->
            <!-- <div class="swiper-button-prev" slot="button-prev"></div> -->
            <!-- @click="next" -->
            <!-- <div class="swiper-button-next" slot="button-next"></div> -->
        </swiper>
    </div>
</template>
<script>
export default {
    props:{
        apptype:{
            type:String
        },
        scource:{
            type:String,
            default:'index'
        },
    },
    created(){
        if(this.apptype=='Roewe'){
            this.commodityList = [
                {
                    link:'https://prw.anyolife.com/goods-detail/2c908af379d2d97c0179f5f73c91307e',
                    img:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202111017eb3931de70ca7b3307165.png',
                    name:'荣威嘉实多保养套餐'
                },
                {
                    link:'https://prw.anyolife.com/goods-detail/2c908af179d2e9150179f619a8e04756',
                    img:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211101060bdd972436e5d6868547.png',
                    name:'荣威美孚保养套餐'
                },
                {
                    link:'https://prw.anyolife.com/goods-detail/2c908af379d2d97c0179f5d6446e304f',
                    img:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202111016500f6b2a85aa474107564.png',
                    name:'荣威臻选保养套餐'
                },
                {
                    link:'https://prw.anyolife.com/goods-detail/4748821b7c931e1e017cbf82bc51289d',
                    img:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/2021110178892030eca6b293453215.png',
                    name:'荣威壳牌原厂保养'
                },
            ]
        }else{
            this.commodityList = [
                {
                    link:'https://mg.anyolife.com/goods-detail/2c908af179d2e9150179f6302ba44775',
                    img:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/202111019f11808e8e379760619922.png',
                    name:'名爵嘉实多保养套餐'
                },
                {
                    link:'https://mg.anyolife.com/goods-detail/2c908af379f6801c0179f6898e680001',
                    img:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211101dfcd7a3c4faf062c805883.png',
                    name:'名爵美孚保养套餐'
                },
                {
                    link:'https://mg.anyolife.com/goods-detail/2c908af179d2e9150179f660e71d47bc',
                    img:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211101e7657181903e7b61347174.png',
                    name:'名爵臻选保养套餐'
                },
                {
                    link:'https://mg.anyolife.com/goods-detail/2c908af37c931539017cbf7f9fb945a7',
                    img:'https://res.xiaoxxx.com/test/m.xiaoxxx.com/20211101979d654c4aa7e078581179.png',
                    name:'名爵壳牌原厂保养'
                },
            ]
        }
    },
    data() {
        return {
            swiperOption: {
                loop: true, //是否循环轮播
                speed: 1000, //切换速度
                observer: true, //修改swiper自己或子元素时，自动初始化swiper
                observeParents: true, //修改swiper的父元素时，自动初始化swiper
                //自动轮播
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false,
                },
                //设置slider容器能够同时显示的slides数量
                slidesPerView: 3,
                //左右切换
                // navigation: {
                //     nextEl: ".swiper-button-next",
                //     prevEl: ".swiper-button-prev",
                // },
                // //分页器
                // pagination: {
                //     el: ".swiper-pagination",
                //     clickable: true, // 允许点击小圆点跳转
                // },
                //设置轮播样式,此处为3d轮播效果
                centeredSlides: true,
                effect: "coverflow",
                // coverflowEffect: {
                //     rotate: 30, // 旋转的角度
                //     stretch: 10, // 拉伸 图片间左右的间距和密集度
                //     depth: 60, // 深度 切换图片间上下的间距和密集度
                //     modifier: 2, // 修正值 该值越大前面的效果越明显
                //     slideShadows: true, // 页面阴影效果
                // },
            },
            commodityList:[],  //商品列表
        }
    },
    methods:{
        skipLink(data){
            window._czc.push(["_trackEvent", this.scource, "商品点击", data.name, "1", "1"]);
            window.location.href = data.link
        }
    }
}
</script>
<style scoped lang="less">
    .swiper{
        max-width: 7.5rem;
    }
    .swiper-list{
        position: relative;
        overflow: hidden;
    }
    .swiper-list img{
        position: absolute;
        left: 0;
        top: 0;
    }
</style>